import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_close.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-dfc9dd6c")

_pushScopeId("data-v-dfc9dd6c")
const _hoisted_1 = {
  key: 0,
  class: "p-4 border border-gray-lp-400 rounded-lg"
}
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "text-20px font-semibold text-gray-lp-300" }, "Atur Shift", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text-20px leading-none" }, "+", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "Tambah Shift", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-x-3 px-4 py-3 bg-orange-lp-500 rounded-lg mb-6"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      cx: "10",
      cy: "10",
      r: "9",
      fill: "#FAB713"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M10 6V11M10 14H10.01",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "text-14px text-yellow-lp-600 font-medium" }, " Pastikan shift diatur penuh mulai jam 00:00 hingga 23:59. ", -1)
const _hoisted_9 = { class: "space-y-4" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid-cols-5 gap-x-4 mb-2\" data-v-dfc9dd6c><div class=\"col-span-1\" data-v-dfc9dd6c><label class=\"text-14px text-gray-lp-300 font-semibold\" data-v-dfc9dd6c>Jam Mulai</label></div><div class=\"col-span-1\" data-v-dfc9dd6c><label class=\"text-14px text-gray-lp-300 font-semibold\" data-v-dfc9dd6c>Jam Berakhir</label></div><div class=\"col-span-3\" data-v-dfc9dd6c><label class=\"text-14px text-gray-lp-300 font-semibold\" data-v-dfc9dd6c>Pilih Kurir</label></div><div class=\"w-10\" data-v-dfc9dd6c></div></div>", 1)
const _hoisted_11 = {
  key: 0,
  class: "shift-row"
}
const _hoisted_12 = { class: "grid grid-cols-5 gap-x-4 items-start" }
const _hoisted_13 = { class: "col-span-1" }
const _hoisted_14 = { class: "px-4 py-2 bg-gray-lp-1500 border border-gray-lp-400 rounded-lg text-14px text-gray-lp-600 h-40px" }
const _hoisted_15 = { class: "col-span-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "text-center text-gray-lp-300 font-normal w-full py-2"
}
const _hoisted_18 = {
  key: 0,
  class: "text-red-lp-750 text-10px mt-1"
}
const _hoisted_19 = {
  key: 1,
  class: "px-4 py-2 bg-gray-lp-1500 border border-gray-lp-400 rounded-lg text-14px text-gray-lp-600 h-40px"
}
const _hoisted_20 = { class: "col-span-3" }
const _hoisted_21 = {
  key: 0,
  class: "flex items-center gap-x-1.5 mt-2 text-red-lp-1200 text-12px"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.255 2.99971C7.03019 1.66676 8.96721 1.66676 9.7424 2.99971L14.3924 10.9997C15.1677 12.3329 14.199 13.9998 12.6487 13.9998H3.34868C1.7984 13.9998 0.829725 12.333 1.6049 10.9998L6.255 2.99971ZM7.9987 5.99983C8.36939 5.99983 8.66989 6.29831 8.66989 6.6665V7.99983C8.66989 8.36802 8.36939 8.6665 7.9987 8.6665C7.62801 8.6665 7.32751 8.36802 7.32751 7.99983V6.6665C7.32751 6.29831 7.62801 5.99983 7.9987 5.99983ZM7.32751 10.6665C7.32751 10.2983 7.62801 9.99983 7.9987 9.99983H8.00541C8.3761 9.99983 8.6766 10.2983 8.6766 10.6665C8.6766 11.0347 8.3761 11.3332 8.00541 11.3332H7.9987C7.62801 11.3332 7.32751 11.0347 7.32751 10.6665Z",
    fill: "#E40101"
  })
], -1)
const _hoisted_23 = { class: "grid grid-cols-5 gap-x-4 items-start" }
const _hoisted_24 = { class: "col-span-1" }
const _hoisted_25 = { class: "px-4 py-2 bg-gray-lp-1500 border border-gray-lp-400 rounded-lg text-14px text-gray-lp-600 h-40px" }
const _hoisted_26 = { class: "col-span-1" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "text-center text-gray-lp-300 font-normal w-full py-2"
}
const _hoisted_29 = {
  key: 0,
  class: "text-red-lp-750 text-10px mt-1"
}
const _hoisted_30 = {
  key: 1,
  class: "px-4 py-2 bg-gray-lp-1500 border border-gray-lp-400 rounded-lg text-14px text-gray-lp-600 h-40px"
}
const _hoisted_31 = { class: "col-span-3" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = { class: "flex-1" }
const _hoisted_34 = { class: "w-10" }
const _hoisted_35 = { class: "w-full h-full flex items-start justify-center" }
const _hoisted_36 = {
  key: 0,
  class: "flex items-center gap-x-1.5 mt-2 text-red-lp-1200 text-12px"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.255 2.99971C7.03019 1.66676 8.96721 1.66676 9.7424 2.99971L14.3924 10.9997C15.1677 12.3329 14.199 13.9998 12.6487 13.9998H3.34868C1.7984 13.9998 0.829725 12.333 1.6049 10.9998L6.255 2.99971ZM7.9987 5.99983C8.36939 5.99983 8.66989 6.29831 8.66989 6.6665V7.99983C8.66989 8.36802 8.36939 8.6665 7.9987 8.6665C7.62801 8.6665 7.32751 8.36802 7.32751 7.99983V6.6665C7.32751 6.29831 7.62801 5.99983 7.9987 5.99983ZM7.32751 10.6665C7.32751 10.2983 7.62801 9.99983 7.9987 9.99983H8.00541C8.3761 9.99983 8.6766 10.2983 8.6766 10.6665C8.6766 11.0347 8.3761 11.3332 8.00541 11.3332H7.9987C7.62801 11.3332 7.32751 11.0347 7.32751 10.6665Z",
    fill: "#E40101"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!

  return (_ctx.isShiftEnabled)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addShift && _ctx.addShift(...args))),
            class: ["flex items-center gap-x-2 text-red-lp-100 text-14px font-semibold hover:opacity-80", [{'cursor-not-allowed text-gray-lp-500': _ctx.shifts.length === 24 || _ctx.isShiftHas23 || !_ctx.isAllShiftValid}]],
            disabled: _ctx.shifts.length === 24 || _ctx.isShiftHas23 || !_ctx.isAllShiftValid
          }, [
            _hoisted_4,
            _hoisted_5
          ], 10, ["disabled"])
        ]),
        (_ctx.showDurationAlert)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", null, [
            _hoisted_10,
            (_ctx.shifts.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, _toDisplayString(_ctx.shifts[0].startTime), 1)
                    ]),
                    _createVNode("div", _hoisted_15, [
                      (_ctx.shifts[0].endTimeEditable)
                        ? (_openBlock(), _createBlock("div", _hoisted_16, [
                            _createVNode(_component_CustomDropdown, {
                              isExpand: _ctx.shifts[0].endTimeExpand,
                              "onUpdate:isExpand": _cache[2] || (_cache[2] = ($event: any) => (_ctx.shifts[0].endTimeExpand = $event)),
                              options: _ctx.timeOptionsFormatted,
                              onSelect: _cache[3] || (_cache[3] = (selected) => _ctx.onSelectEndTime(0, selected)),
                              placeholder: "Pilih Waktu",
                              customClassHeight: "h-40px",
                              selectedItem: _ctx.shifts[0].selectedEndTime,
                              customBorderColor: _ctx.shifts[0].endTimeError ? 'border-red-lp-750' : 'border-gray-lp-400',
                              customValueStyle: "text-14px",
                              customBorderRadius: "-lg"
                            }, {
                              default: _withId(() => [
                                (_ctx.timeOptionsFormatted.length === 0)
                                  ? (_openBlock(), _createBlock("div", _hoisted_17, " Tidak ada pilihan jam "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["isExpand", "options", "selectedItem", "customBorderColor"]),
                            (_ctx.shifts[0].endTimeError)
                              ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.shifts[0].endTimeError), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_19, _toDisplayString(_ctx.shifts[0].endTime), 1))
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode(_component_SelectSearch, {
                        modelValue: _ctx.shifts[0].selectedCourier,
                        options: _ctx.shifts[0].courierList,
                        placeholder: "Pilih kurir",
                        keyName: "displayName",
                        keyValue: "id",
                        customClassInput: "h-40px",
                        customBorderRadiusInput: "rounded-lg",
                        isLoading: _ctx.shifts[0].courierIsLoading,
                        maxHeight: "155px",
                        onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fetchCouriersForRow(0))),
                        onFilter: _cache[5] || (_cache[5] = (keyword) => _ctx.filterCouriersForRow(0, keyword)),
                        onScrolled: _cache[6] || (_cache[6] = () => _ctx.loadMoreCouriersForRow(0)),
                        onChange: _cache[7] || (_cache[7] = (selected) => _ctx.onSelectCourier(0, selected)),
                        onClose: _cache[8] || (_cache[8] = () => _ctx.onCloseCourierSelect(0)),
                        onClear: _cache[9] || (_cache[9] = () => _ctx.onClearCourier(0)),
                        isShowErrorIndicator: !!_ctx.shifts[0].courierError,
                        useInfiniteScroll: ""
                      }, null, 8, ["modelValue", "options", "isLoading", "isShowErrorIndicator"]),
                      (_ctx.shifts[0].courierError)
                        ? (_openBlock(), _createBlock("div", _hoisted_21, [
                            _hoisted_22,
                            _createVNode("span", null, _toDisplayString(_ctx.shifts[0].courierError), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shifts.slice(1), (shift, index) => {
            return (_openBlock(), _createBlock("div", {
              key: shift.id,
              class: "shift-row"
            }, [
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, _toDisplayString(shift.startTime || '-'), 1)
                ]),
                _createVNode("div", _hoisted_26, [
                  (shift.endTimeEditable)
                    ? (_openBlock(), _createBlock("div", _hoisted_27, [
                        _createVNode(_component_CustomDropdown, {
                          isExpand: shift.endTimeExpand,
                          "onUpdate:isExpand": ($event: any) => (shift.endTimeExpand = $event),
                          options: _ctx.timeOptionsFormatted,
                          onSelect: (selected) => _ctx.onSelectEndTime(index + 1, selected),
                          placeholder: "Pilih Waktu",
                          customClassHeight: "h-40px",
                          selectedItem: shift.selectedEndTime,
                          customBorderColor: shift.endTimeError ? 'border-red-lp-750' : 'border-gray-lp-400',
                          customValueStyle: "text-14px",
                          customBorderRadius: "-lg"
                        }, {
                          default: _withId(() => [
                            (_ctx.timeOptionsFormatted.length === 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_28, " Tidak ada pilihan jam "))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["isExpand", "onUpdate:isExpand", "options", "onSelect", "selectedItem", "customBorderColor"]),
                        (shift.endTimeError)
                          ? (_openBlock(), _createBlock("div", _hoisted_29, _toDisplayString(shift.endTimeError), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_30, _toDisplayString(shift.endTime), 1))
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _createVNode("div", _hoisted_33, [
                      _createVNode(_component_SelectSearch, {
                        modelValue: shift.selectedCourier,
                        options: shift.courierList,
                        placeholder: "Pilih kurir",
                        keyName: "displayName",
                        keyValue: "id",
                        customClassInput: "h-40px rounded-lg",
                        isLoading: shift.courierIsLoading,
                        maxHeight: "155px",
                        onFocus: ($event: any) => (_ctx.fetchCouriersForRow(index + 1)),
                        onFilter: (keyword) => _ctx.filterCouriersForRow(index + 1, keyword),
                        onScrolled: () => _ctx.loadMoreCouriersForRow(index + 1),
                        onChange: (selected) => _ctx.onSelectCourier(index + 1, selected),
                        onClose: () => _ctx.onCloseCourierSelect(index + 1),
                        onClear: () => _ctx.onClearCourier(index + 1),
                        isShowErrorIndicator: !!shift.courierError,
                        useInfiniteScroll: ""
                      }, null, 8, ["modelValue", "options", "isLoading", "onFocus", "onFilter", "onScrolled", "onChange", "onClose", "onClear", "isShowErrorIndicator"])
                    ]),
                    _createVNode("div", _hoisted_34, [
                      _createVNode("div", _hoisted_35, [
                        _createVNode("img", {
                          src: _imports_0,
                          class: "w-24px opacity-70 cursor-pointer hover:opacity-100",
                          alt: "delete",
                          onClick: ($event: any) => (_ctx.deleteShift(index + 1))
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ]),
                  (shift.courierError)
                    ? (_openBlock(), _createBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _createVNode("span", null, _toDisplayString(shift.courierError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
})